import _ from 'lodash'

// eslint-disable-next-line max-statements
export function getShortcut(row) {
  let shortcutId = null
  let shortcutTargetPage = null
  let relatedId = null
  let target = ''
  const jobType = row.job_id ? row.job_type.replace('/', '-') : ''

  if (!_.isNull(row.proposal_id)) {
    shortcutId = row.proposal_id
    shortcutTargetPage = `/lead/${row.lead_id}/proposals/edit/${row.proposal_id}`
  } else if (!_.isNull(row.estimate_id)) {
    shortcutId = row.estimate_id
    if (row.job_id) {
      shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/site-estimates`
    } else {
      shortcutTargetPage = `/lead/${row.lead_id}/estimates/edit/${row.estimate_id}`
    }
  } else if (!_.isNull(row.contract_id)) {
    shortcutId = row.contract_id
    shortcutTargetPage = `/lead/${row.lead_id}/contracts/edit/${row.contract_id}`
  } else if (!_.isNull(row.proposal_id)) {
    shortcutId = row.proposal_id
    shortcutTargetPage = `/lead/${row.lead_id}/proposals/edit/${row.proposal_id}`
  } else if (!_.isNull(row.change_order_id)) {
    shortcutId = row.change_order_id
    relatedId = row.change_order_number
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/change-orders`
  } else if (!_.isNull(row.drawing_id)) {
    shortcutId = row.drawing_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/drawings`
  } else if (!_.isNull(row.payment_request_id)) {
    shortcutId = row.payment_request_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/payment-requests/modal/${
      row.payment_request_id
    }`
  } else if (!_.isNull(row.aia_id)) {
    shortcutId = row.aia_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/aias/modal/${row.aia_id}`
  } else if (!_.isNull(row.invoice_id)) {
    shortcutId = row.invoice_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/invoices/modal/${row.invoice_id}`
  } else if (!_.isNull(row.material_request_id)) {
    shortcutId = row.material_request_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/material-requests/modal/${
      row.material_request_id
    }`
  } else if (!_.isNull(row.schedule_id)) {
    shortcutId = row.schedule_id
    shortcutTargetPage = ''
  } else if (!_.isNull(row.schedule_drawing_id)) {
    shortcutId = row.schedule_drawing_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/schedule-drawings`
  } else if (!_.isNull(row.schedule_manufacturing_id)) {
    shortcutId = row.schedule_manufacturing_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/manufacturing`
  } else if (!_.isNull(row.schedule_application_id)) {
    shortcutId = row.schedule_application_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/applications`
  } else if (!_.isNull(row.schedule_site_work_id)) {
    shortcutId = row.schedule_site_work_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/sitework`
  } else if (!_.isNull(row.stop_call_id)) {
    shortcutId = row.stop_call_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/stop-calls`
  } else if (!_.isNull(row.rfi_id)) {
    shortcutId = row.rfi_id
    if (row.job_id) {
      shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/site-rfi`
    } else {
      shortcutTargetPage = `/lead/${row.lead_id}/rfis`
    }
  } else if (!_.isNull(row.transmittal_id)) {
    shortcutId = row.transmittal_id
    if (row.job_id) {
      shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/transmittals`
    } else {
      shortcutTargetPage = `/lead/${row.lead_id}/transmittals`
    }
  } else if (!_.isNull(row.employee_id)) {
    shortcutId = row.employee_id
    shortcutTargetPage = '/employees'
    target = 'jobView'
  } else if (!_.isNull(row.purchase_order_id)) {
    shortcutId = row.purchase_order_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/vendors/purchase-order/modal/${
      row.purchase_order_id
    }`
  } else if (!_.isNull(row.violation_id)) {
    shortcutId = row.violation_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/violations`
  } else if (!_.isNull(row.vehicle_id)) {
    shortcutId = row.vehicle_id
    shortcutTargetPage = `/jobView/${row.job_id}/${jobType}/vehicles`
  }

  return {
    shortcutId: shortcutId,
    shortcutTargetPage: shortcutTargetPage,
    relatedId: relatedId,
    target: target
  }
}



// WEBPACK FOOTER //
// ./src/util/dashboardFollowUps.js